import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles/techproficiency.css';
import TechProficiencyIcon from '../../../../../assets/images/technical proficiency.png';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
const TechnicalProficiencyPanel = ({ techproficiency = {} }) => {
  const calculatePercentage = (rating) => ((rating ?? 0) / 5) * 100;

  return (
    <Row className="profile-technical-proficiency-item mt-2">
      <Col md={12}>
        <Row className="d-none d-md-flex align-items-center">
          <Col md={1} className="d-flex align-items-center">
            <div className="profile-technical-proficiency-item-icon">
              <img src={TechProficiencyIcon} alt="Tech Proficiency Icon" />
            </div>
          </Col>
          <Col md={8} className="d-flex align-items-center">
            {techproficiency.skill && (
              <div className="profile-technical-proficiency-item-name">
                {techproficiency.skill}
              </div>
            )}
          </Col>
          <Col md={3} className="d-flex justify-content-end align-items-center">
            <div className="profile-technical-proficiency-item-percentage">
              {calculatePercentage(techproficiency.rating)}%
            </div>
          </Col>
        </Row>

        {/* Small Screen Layout */}
        <div className="d-md-none">
          <div className="d-flex align-items-center justify-content-between">
            <div className="profile-technical-proficiency-item-icon">
              <img src={TechProficiencyIcon} alt="Tech Proficiency Icon" />
            </div>
            {techproficiency.skill && (
              <div className="profile-technical-proficiency-item-name">
                {techproficiency.skill}
              </div>
            )}
            <div className="profile-technical-proficiency-item-percentage">
              {calculatePercentage(techproficiency.rating)}%
            </div>
          </div>
        </div>
        <Row>
          <Col>
            <div className="profile-technical-proficiency-item-bar">
              <div
                className="profile-technical-proficiency-item-bar-fill"
                style={{
                  width: `${calculatePercentage(techproficiency.rating)}%`,
                }}
              ></div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default TechnicalProficiencyPanel;